"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: false
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        type: 'select',
        key: 'pageSize',
        label: 'Page Size',
        input: true,
        dataSrc: 'values',
        weight: 100,
        tooltip: 'This is default number of item per page.',
        defaultValue: '15',
        data: {
            values: [
                { label: '15', value: '15' },
                { label: '30', value: '30' },
                { label: '50', value: '50' },
                { label: '100', value: '100' }
            ],
        },
    },
    {
        type: 'select',
        key: 'align',
        label: 'Align',
        input: true,
        dataSrc: 'values',
        weight: 100,
        tooltip: 'Align.',
        data: {
            values: [
                { label: 'Left', value: 'justify-content-start' },
                { label: 'Center', value: 'justify-content-center' },
                { label: 'Right', value: 'justify-content-end' },
                { label: 'Full', value: 'justify-content-between' }
            ],
        },
    },
    {
        type: 'select',
        key: 'action',
        label: 'Action',
        input: true,
        dataSrc: 'values',
        weight: 101,
        tooltip: 'This is the action to be performed by this button.',
        data: {
            values: [
                // { label: 'POST to Ari', value: 'aripost' },
                { label: 'Event', value: 'event' },
                { label: 'Custom', value: 'custom' },
            ],
        },
    },
    {
        type: 'textfield',
        label: 'Event Name',
        key: 'event',
        input: true,
        weight: 102,
        tooltip: 'The event to fire when the button is clicked.',
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'event'] },
        },
    },
    {
        type: 'textarea',
        key: 'custom',
        label: 'Button Custom Logic',
        tooltip: 'The custom logic to evaluate when the button is clicked.',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 103,
        placeholder: "data['mykey'] = data['anotherKey'];",
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'custom'] },
        },
    },
    {
        type: 'textfield',
        key: 'previousName',
        label: 'Previous Button Name',
        input: true,
        weight: 104,
        tooltip: 'Text will showing on previous button',
    },
    {
        type: 'textfield',
        key: 'nextName',
        label: 'Next Button Name',
        input: true,
        weight: 105,
        tooltip: 'Text will showing on next button',
    },
    {
        type: 'checkbox',
        key: 'allowChangePageSize',
        label: 'Allow user change Page Size',
        input: true,
        weight: 106,
        tooltip: 'Allow user change page size',
    },
    {
        type: 'checkbox',
        key: 'notshowPageNumber',
        label: 'Hide Page Number',
        input: true,
        weight: 106,
        tooltip: 'Hide page number',
    },
    {
        type: 'checkbox',
        key: 'displayInfo',
        label: 'Display pagination information',
        input: true,
        weight: 106,
        tooltip: 'Display pagination information',
    },
    {
        type: 'checkbox',
        key: 'addFirstLastBtn',
        label: 'Add Fist and Last Button',
        input: true,
        weight: 107,
        tooltip: 'Add Fist and Last Button',
    },
    {
        type: 'textfield',
        key: 'firstName',
        label: 'First Button Name',
        input: true,
        weight: 108,
        tooltip: 'Text will showing on first button',
        conditional: {
            json: { '===': [{ var: 'data.addFirstLastBtn' }, true] },
        },
    },
    {
        type: 'textfield',
        key: 'lastName',
        label: 'Last Button Name',
        input: true,
        weight: 108,
        tooltip: 'Text will showing on last button',
        conditional: {
            json: { '===': [{ var: 'data.addFirstLastBtn' }, true] },
        },
    },
    {
        type: 'number',
        label: 'Maximum Number Button',
        key: 'numBtn',
        input: true,
        weight: 109,
        placeholder: 'Maximum Number Button',
        tooltip: 'Maximum Number Button (must be odd)'
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'theme',
        label: 'Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of buttons.',
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'themeActive',
        label: 'Active Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of Active button.',
    },
];
